module.exports = __webpack_public_path__ + "static/media/R0.7710fc66.webp";